export default __webpack_public_path__ + "static/Digital_HP_Branded_Tearsheet-731a3fb6f5a7d092499909afe9e3b799.pdf";